import React, { Component } from 'react';

import PriceRangeFilter from './PriceRangeFilter';
import CategoriesFilter from './CategoriesFilter';

class HeaderFiltersBtns extends Component {
  constructor(props) {
    super(props);
    this.labels = this.props.labels;
    this.giftsPerPage = this.props.giftsPerPage;
    this.eventId = this.props.eventId;
    this.categoryList = this.props.categoryList;
    this.state = { id: '' };
  }

  handlePriceRangeFilter = (_, e) => {
    const { options, selectedIndex } = e.target;
    this.setState({ id: options[selectedIndex].id }, () => {
      this.filterPerPrice();
    });
  }

  filterPerPrice = () => {
    this.props.typeOrder(this.state.id);
    this.props.getGiftListGuestView(this.eventId, this.state.id, '', '1', 'false', this.giftsPerPage);
  }

  filterCategories = (e) => {
    this.props.getCategoryForHeader(e.id);
    this.props.getGiftListGuestView(
      this.eventId,
      (this.state.id || 'Ascending'),
      e.id,
      '1',
      'false',
      this.giftsPerPage,
    );
  }

  render() {
    return (
      <div className="stickyFiltersBtns">
        <PriceRangeFilter
          labels={this.labels}
          handlePriceRangeFilter={this.handlePriceRangeFilter}
        />

        <CategoriesFilter
          categoryList={this.categoryList}
          filterCategories={this.filterCategories}
        />
      </div>
    );
  }
}


export default HeaderFiltersBtns;

